(function($) {
     $(function() {

        if(typeof angular === 'undefined') {
            return false;
        }

        if (supapress_config.angularjs_support === 'true') {
            angular.module('supapressAngular', []).run(['$window', '$rootScope', '$location', function ($window, $rootScope, $location) {
                $window.supapress = $window.supapress || {};
                $window.supapress.angular = $window.supapress.angular || {};
                $window.supapress.angular.changeURL = function (url) {
                    // Function to apply a url change
                    $rootScope.$apply(function () {
                        // Strip domain from URL
                        $location.url(url.replace(window.supapress_config.blog_details.site_url, ''));
                    });
                };
            }]);
        }
    });
})(jQuery);
(function($) {
    $('body').on('DOMNodeInserted', function(e) {
        var $eTarget = $(e.target), $search, $carousel,
            initSearches = function($search) {
                $search.each(function() {
                    var $this = $(this);

                    if(!$this.data('supapressInitialised')) {
                        $this.supapressSearchInit();
                    }
                });
            },
            initCarousels = function($carousel) {
                $carousel.each(function() {
                    var $this = $(this);

                    if(!$this.data('supapressInitialised')) {
                        $this.supapressInit();
                    }
                });
            };

        // cater for the normal inserted divs on frontend
        if ($eTarget.is('div.supapress')) {
            $search = $eTarget.find('.search');
            $carousel = $eTarget.find('.isbn-carousel');

            initSearches($search);
            initCarousels($carousel);
        } else if ($eTarget.find('div.supapress').length > 0) {
            $eTarget.find('div.supapress').each(function(index, value) {
                var $elem = $(value);

                $search = $elem.find('.search');
                $carousel = $elem.find('.isbn-carousel');

                initSearches($search);
                initCarousels($carousel);
            });
        }
    });
})(jQuery);

(function($) {
    window.supapress = window.supapress || {};

    var debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    supapress.gridAlign = function(maxHeight, $layout) {
        var $wrapper = $layout.find('[data-baseline-images=wrapper]');
        $wrapper.height(maxHeight);
        $wrapper.find('[data-baseline-images=image]').addClass('baselined');
        $layout.data('aligned', true);
    };

    supapress.showRetailerLinks = function($button, $layout) {
        $button.on('click', function(e) {
            if( !$(this).next().hasClass('open') ) {
                $layout.find('.sp__the-retailers--list.open').removeClass('open');
                $(this).next().addClass('open');
            } else {
                $(this).next().removeClass('open');
            }
        });
    };

    supapress.setMaxCoverHeight = function($layout) {
        var $wrapper = $layout.find('[data-baseline-images=wrapper]'),
            $images = $wrapper.find('[data-baseline-images=image]'),
            settings = $layout.data('carouselSettings') || {},
            count = 0,
            maxHeight = 0,
            alignOnNextPrev = false,
            onload;

        $wrapper.addClass('image-wrapper');
        $images.addClass('supapress-book-cover');

        if(typeof settings.lazyLoad !== 'undefined') {
            $layout.on('beforeChange', function() {
                alignOnNextPrev = true;
            });
        }

        if(!$layout.data('aligned')) {
            $images.on('load', function (e) {
                var $this = $(this);

                // if lazyloading then first load will be placeholder, second will be real image
                // if not lazy loading then this will be real image
                // once real image has loaded we turn off the load event and use the each below instead
                if (typeof settings.lazyLoad === 'undefined' || $this.attr('src') !== settings.lazyLoadPlaceholder) {
                    count++;
                    $this.off('load');
                }

                if ($this.height() > maxHeight) {
                    maxHeight = $this.height();
                }

                // only fire while images are loading if the visible ones have finished loading
                // don't want grid align to fire too much
                if (count === $images.length || (typeof settings.lazyLoad !== 'undefined' && (count === settings.slidesToShow || alignOnNextPrev))) {
                    alignOnNextPrev = false;
                    return supapress.gridAlign(maxHeight, $layout);
                }
            }).each(function() {
                if (this.complete) {
                    $(this).trigger('load');
                }
            });
        } else {
            $images.each(function (index) {
                var $this = $(this);

                if ($this.height() > maxHeight) {
                    maxHeight = $this.height();
                }

                // on the last image in the loop fire the grid alignment
                if (index === ($images.length - 1)) {
                    supapress.gridAlign(maxHeight, $layout);
                }
            });
        }
    };

    $.fn.supapressInit = function() {
        var $layout = this;

        if( $layout.hasClass('isbn-carousel') && typeof $.fn.slick !== 'undefined' ) {
            $layout.parent().css('overflow', 'visible');

            var $carouselContainer = $layout.find('[data-container="carousel"]');

            if( $carouselContainer.length === 1 ) {
                $carouselContainer.slick($layout.data('carouselSettings'));
            } else {
                $layout.slick($layout.data('carouselSettings'));
            }
        }

        if( $layout.hasClass('isbn-grid') || $layout.hasClass('isbn-carousel') || $layout.hasClass('isbn-list') ) {
            var $toggleRetailerBtn = $layout.find('.js-show-sp__the-retailers');
            supapress.showRetailerLinks($toggleRetailerBtn, $layout);
        }

        if( $layout.hasClass('isbn-grid') || $layout.hasClass('isbn-carousel') || $layout.hasClass('search-grid') ) {
            var debounceResize = debounce(function() {
                supapress.setMaxCoverHeight($layout);
            }, 300);
            $(window).on('resize orientationchange', debounceResize);
        }

        $layout.data('supapressInitialised', true);
    };

    $('div.supapress > div').each(function() {
        $(this).supapressInit();
    });

    $(window).trigger('resize');
})(jQuery);

(function($) {
    window.supapress = window.supapress || {};

    supapress.$searchLayout = null;

    supapress.$sortBy = null;

    supapress.$perPage = null;

    supapress.$pagination = null;

    supapress.$previous = null;

    supapress.$page = null;

    supapress.$next = null;

    supapress.ajaxURL = null;

    supapress.params = null;

    supapress.current = null;

    supapress.total = null;

    supapress.reload = function(name, value) {
        // Get base url
        var baseUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;

        if(typeof name !== 'undefined' && typeof value !== 'undefined') {
            // Get current query string
            var query = window.location.search.substring(1);

            // Split up query into array
            var params = query.split('&');

            query = '';

            // Loop query params
            for (var i=0; i<params.length; i++) {
                // Split into key value pair
                var param = params[i].split('=');

                // If the key is blank (i.e. no query string) or the value is undefined or blank and the key is not the new param continue
                if(param[0] === '' || (typeof param[1] === 'undefined' && param[0] !== name) || (param[1] === '' && param[0] !== name) || (param[0] === name && value === false)) {
                    continue;
                }

                // Reset page number is any other params change as the result set changes to start from page 1
                if(param[0] === 'page_number' && name !== 'page_number') {
                    param[1] = 1;
                }

                // Add the key pair to the query string
                query += query === '' ? '' : '&';
                query += param[0] + '=';
                query += param[0] === name ? value : param[1];
            }

            // Build regex param= to make sure it's been added
            var regex = new RegExp(name + '=', 'g');

            // If the new param is not added yet then added
            if(regex.test(query) === false && value !== false) {
                query += query === '' ? '' : '&';
                query += name + '=' + value;
            }

            // reload the page with the new url
            if($.trim(query) !== '') {
                supapress.changeLocationhref(baseUrl + '?' + query);
            } else {
                supapress.changeLocationhref(baseUrl);
            }
        } else {
            supapress.changeLocationhref(baseUrl);
        }
    };

    supapress.changeLocationhref = function(url) {
        window.location.href = url;
    };

    supapress.loadFilters = function() {
        $.each(supapress.$searchLayout.find('.filter-load-wrapper'), function() {
            var $this = $(this);

            $.ajax({
                url: supapress.ajaxURL + '?action=supapress_filters',
                type: 'GET',
                data: {
                    params: supapress.params,
                    showText: $this.data('show-text'),
                    hideText: $this.data('hide-text'),
                    clearText: $this.data('clear-text'),
                    limits: $this.data('filter-limits'),
                    filters: $this.data('filters')
                },
                success: function( response ) {
                    $this.html( response ).removeClass('preloader-on');

                    $this.find('a').on('click', function(event) {
                        var $this = $(this);

                        if($this.hasClass('clear-filters')) {
                            supapress.reload();
                        } else if($this.hasClass('clear-filter') && $this.attr('data-name')) {
                            supapress.reload($this.attr('data-name'), false);
                        } else if($this.attr('data-name') && $this.attr('data-seo')) {
                            supapress.reload($this.attr('data-name'), $this.attr('data-seo'));
                        }
                    });

                    $this.find('.additional-filters').each(function(index, elem) {
                        var $elem = $(elem),
                            height = $elem.height();

                        $elem.css('height', height).data('height', height).css('maxHeight', 0);
                    });

                    $this.find('.additional-filters-toggle').on('click', function() {
                        var $toggle = $(this),
                            $additonalFilters = $toggle.parents('.filter-block').find('.additional-filters');

                        if($additonalFilters.css('maxHeight') !== '0px') {
                            $toggle.text($toggle.data('showLabel'));
                            $additonalFilters.css('maxHeight', 0);
                        } else {
                            $toggle.text($toggle.data('hideLabel'));
                            $additonalFilters.css('maxHeight', $additonalFilters.data('height'));
                        }
                    });
                }
            });
        });
    };

    $.fn.supapressSearchInit = function() {
        supapress.$searchLayout = this;
        supapress.$sortBy = supapress.$searchLayout.find('.supapress-sort-by');
        supapress.$perPage = supapress.$searchLayout.find('.supapress-per-page');
        supapress.$pagination = supapress.$searchLayout.find('.supapress-pagination-wrapper');
        supapress.$previous = supapress.$pagination.find('.supapress-previous');
        supapress.$page = supapress.$pagination.find('.supapress-page');
        supapress.$next = supapress.$pagination.find('.supapress-next');
        supapress.ajaxURL = supapress.$searchLayout.parents('.supapress').data('ajax-url');
        supapress.params = supapress.$searchLayout.parents('.supapress').data('widget-params');
        supapress.current = parseInt(supapress.$pagination.attr('data-current'));
        supapress.total = parseInt(supapress.$pagination.attr('data-total'));

        // Load filters
        supapress.loadFilters();

        // Add event listeners for sort by
        supapress.$sortBy.on('change', function() {
            supapress.reload('supapress_order', $(this).val());
        });

        // Add event listeners for per page
        supapress.$perPage.on('change', function() {
            supapress.reload('amount', $(this).val());
        });

        // Add event listeners for previous page
        supapress.$previous.on('click', function() {
            if(supapress.current === 1) {
                supapress.reload('page_number', supapress.total);
            } else {
                supapress.reload('page_number', supapress.current - 1);
            }
        });

        // Add event listeners for page changer
        supapress.$page.on('click', function() {
            supapress.reload('page_number', $(this).attr('data-page'));
        });

        // Add event listeners for next page
        supapress.$next.on('click', function() {
            if(supapress.current === supapress.total) {
                supapress.reload('page_number', 1);
            } else {
                supapress.reload('page_number', supapress.current + 1);
            }
        });

        supapress.$searchLayout.data('supapressInitialised', true);
    };

    $('div.supapress .search').supapressSearchInit();
})(jQuery);